import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const NAVIGATION_EVENT_NAMES = {
  LOGOUT_CLICK: 'user_clicks_logout_button_from_menu',
};

const CENTRAL_STATION = 'central_station';

export const trackLogOutClick = (currentApp, irpVersion) => {
  const appName = currentApp === CENTRAL_STATION ? 'CSP' : 'RSP';

  gspx.trackEvent({
    name: NAVIGATION_EVENT_NAMES.LOGOUT_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.NAVBAR,
    additionalKeys: {
      legacy_category: 'Auth',
      legacy_name: `user clicks on logout button from menu in ${appName}`,
      Category: 'Auth',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
